import { call, put, takeLatest } from "redux-saga/effects";
import request from "../../api/request";

function* getAllServiceTypes() {
  try {
    yield put({
      type: "FETCH_LOGISTICS_SERVICE_TYPES_REQUESTING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/logistics-service-types`;
    const headers = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "FETCH_LOGISTICS_SERVICE_TYPES_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "FETCH_LOGISTICS_SERVICE_TYPES_ERROR",
    });
  }
}

export function* watchLogisticsServiceType() {
  yield takeLatest("FETCH_LOGISTICS_SERVICE_TYPES_REQUEST", getAllServiceTypes);
}
